import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/@service/app.service';


@Component({
  selector: 'app-our-team',
  templateUrl: './our-team.component.html',
  styleUrls: ['./our-team.component.scss']
})
export class OurTeamComponent implements OnInit {

  teamList: any[] = [];

  isLoading = false;

  constructor(
    private _appService: AppService
  ) {}

  ngOnInit(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.getTeamData();
  }

  getTeamData(): void {
    this.isLoading = true;

    this._appService.getTeam().subscribe({
      next: (data: any) => {
        this.teamList = (data.items || []).sort(
          (a: any, b: any) =>
            Number(a.display_order) - Number(b.display_order)
        );

        this.isLoading = false;
      },
      error: (error: any) => {
        console.error('Team API Error:', error);
        this.isLoading = false;
      }
    });
  }

  getTeamImage(team: any): string {
    return team.image?.[0] || 'assets/default-user.png';
  }
}